import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { AutoRefreshTokenService, includeBearerTokenInterceptor, provideKeycloak, withAutoRefreshToken, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, createInterceptorCondition, IncludeBearerTokenCondition, UserActivityService } from 'keycloak-angular';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { sessionExpiredInterceptor } from './core/auth/session-expired.interceptor';


// Definimos la condición con Regex para tu API local o de Donweb
const apiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^(${environment.apiUrl})(\/.*)?$`, 'i')
});

export const appConfig: ApplicationConfig = {
  providers: [
    // 1. EL CLIENTE HTTP DEBE ESTAR DISPONIBLE PRIMERO
    provideHttpClient(
      withFetch(),
      withInterceptors([includeBearerTokenInterceptor, sessionExpiredInterceptor])
    ),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes), provideClientHydration(withEventReplay()),
    // 2. Registramos el servicio manualmente si el feature falla
     //AutoRefreshTokenService,
  provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },
      initOptions: {
        onLoad: 'login-required',
        // Importante: Keycloak 26.x es estricto con los trailing slashes
        silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`
      },      
     features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'login',
          sessionTimeout: 300000 // 5 minutos de gracia para los operarios
        })
      ],
      // AQUÍ REGISTRAMOS LOS PROVEEDORES QUE FALTABAN
      providers: [
        AutoRefreshTokenService,
        UserActivityService,
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [apiCondition] // El array que soluciona el .find()
        }
      ]
    })
  ]
};
